// extracted by mini-css-extract-plugin
export default {"Form":"BookForm_Form__bTDFn","Stars":"BookForm_Stars__krl3T","AddImage":"BookForm_AddImage__KfX8t"};